module.exports = __webpack_public_path__ + "static/img/beers.570a6bf9.svg";